export enum EnvironmentsEnum {
    tiller = "tiller",
    woods = "woods",
    mcInroy = "mcInroy"
  }